let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iw41J")).then(() => parcelRequire('94GP6'));